import { useMemo } from "react";

import { BlockIcon, ClientIcon } from "components/icons";
import Image, { ImageProps } from "components/Image";

import { useTranslationContext } from "context/TranslationContext";
import cn from "lib/cn";

import { EAccount } from "types/index";

interface PersonalProfilePhotoProps extends ImageProps {
  type: EAccount;
  isBlacklisted?: boolean;
  badgeIconClassName?: string;
  badgeIconSize?: {
    height: number;
    width: number;
  };
}

const PersonalProfilePhoto = ({
  type,
  isBlacklisted,
  className,
  badgeClassName,
  badgeIconClassName,
  badgeIconSize,
  ...rest
}: PersonalProfilePhotoProps) => {
  const { t } = useTranslationContext();

  const withTooltip = useMemo(() => {
    return isBlacklisted;
  }, [isBlacklisted]);

  const tooltipText = useMemo(() => {
    if (isBlacklisted) return t("blacklisted");
    return "";
  }, [isBlacklisted, t]);

  return (
    <div>
      <Image
        {...rest}
        withTooltip={withTooltip || rest.withTooltip}
        tooltipText={tooltipText || rest.tooltipText}
        className={cn(
          "text-2xl font-medium bg-gradient-to-t from-gradient3-500 to-gradient3-200/50",
          className
        )}
        borderRadius={type === EAccount.STAFF ? "15%" : "50%"}
        badgeClassName={cn(
          type === EAccount.CLIENT
            ? "bg-primary-500 right-[10px] bottom-[10px] w-[18px] h-[18px] flex items-center justify-center p-0"
            : undefined,
          badgeClassName
        )}
        badgeIcon={
          type === EAccount.CLIENT ? (
            <ClientIcon
              width={badgeIconSize?.width || 10}
              height={badgeIconSize?.height || 10}
              className={cn("text-white", badgeIconClassName)}
            />
          ) : type === EAccount.STAFF && isBlacklisted ? (
            <div className="text-red-500">
              <BlockIcon
                width={badgeIconSize?.width || 20}
                height={badgeIconSize?.height || 20}
                className={cn(
                  "bg-white rounded-full p-[2px]",
                  badgeIconClassName
                )}
              />
            </div>
          ) : undefined
        }
      />
    </div>
  );
};

export default PersonalProfilePhoto;
